import { Modal } from '@mantine/core';
import useCreatePaymentMethod from '../../../hooks/payment-methods/useCreatePaymentMethod.ts';
import { CreatePaymentMethodRequest } from '../../../api/requests/payment-method-request.ts';
import { notifyError } from '../../../utils/NotifyError.tsx';
import MutatePaymentMethodForm, {
  MutatePaymentMethodFormValues,
} from '../../ui/payment-methods/MutatePaymentMethodForm.tsx';
import { useMutation } from '@tanstack/react-query';
import { ErrorResponse } from '../../../api/responses/error-response.ts';

interface AddPaymentMethodModalProps {
  opened: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const AddPaymentMethodModal = ({
  opened,
  onClose,
  onSuccess,
}: AddPaymentMethodModalProps) => {
  const { mutateAsync: createPaymentMethod } = useCreatePaymentMethod();

  const { mutate: handleSubmit, isPending: isCreatePaymentMethodPending } =
    useMutation<void, ErrorResponse, MutatePaymentMethodFormValues>({
      mutationFn: async (formValues) => {
        const createPaymentMethodRequest: CreatePaymentMethodRequest = {
          name: formValues.name,
        };

        await createPaymentMethod(createPaymentMethodRequest);
      },
      onSuccess: () => {
        onSuccess();
      },
      onError: (error) => {
        if (error.code === 'PAYMENT_METHOD_NAME_ALREADY_EXISTS') {
          return notifyError('新增場站付款方式失敗', '付款方式名稱已存在');
        } else {
          notifyError('新增場站付款方式失敗', error.message);
        }
      },
    });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="新增場站付款方式"
      centered
      closeOnClickOutside={false}
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      <MutatePaymentMethodForm
        initialValues={{
          name: '',
        }}
        onSubmit={handleSubmit}
        onCancel={onClose}
        isSubmitting={isCreatePaymentMethodPending}
      />
    </Modal>
  );
};

export { AddPaymentMethodModal };
